import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  JagdProduktPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, getAnzeigenamen, Produktlinie } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { IAppState } from '../appState';
import { JhpActions } from '../jhpActions';
import { Versicherungsnehmer } from '../reducers/versicherungsnehmer.reducer';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(JhpActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.JHP));
  yield takeEvery(JhpActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.JHP));
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  const produktActionData: JagdProduktPayload = {
    appId: App.JHP,
    angebotsId: state.angebotsId,
    uebersichtTitle: getAnzeigenamen(App.JHP),
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    versichertesRisiko: getVersichertesRisiko(state.versicherungsnehmer),
    beginndatum: state.vertragsoptionen.beginnDatum,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktActionData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);

  yield put(new JhpActions().vorschlagdatenChanged());

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.JHP,
      angebotsId: state.angebotsId,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      versichertesRisiko: getVersichertesRisiko(state.versicherungsnehmer),
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}

function getVersichertesRisiko(versicherungsnehmer: Versicherungsnehmer): string {
  const adresse = versicherungsnehmer.adresse;
  return `${adresse.strasse} ${adresse.hausnummer}, ${adresse.plz} ${adresse.ort}`;
}
